"use client";

/** 클라이언트 컴포넌트에서 쓰는 API 호출 헬퍼 */

export type ApiResult<T = unknown> = { ok: true; data: T } | { ok: false; error: string };

async function request<T>(method: string, url: string, body?: unknown): Promise<ApiResult<T>> {
  try {
    const res = await fetch(url, {
      method,
      headers: body instanceof FormData ? undefined : { "Content-Type": "application/json" },
      body: body instanceof FormData ? body : body !== undefined ? JSON.stringify(body) : undefined,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json?.ok === false) {
      return { ok: false, error: json?.error ?? `요청에 실패했습니다. (HTTP ${res.status})` };
    }
    return { ok: true, data: json.data as T };
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : "네트워크 오류가 발생했습니다." };
  }
}

export const api = {
  get: <T,>(url: string) => request<T>("GET", url),
  post: <T,>(url: string, body?: unknown) => request<T>("POST", url, body),
  patch: <T,>(url: string, body?: unknown) => request<T>("PATCH", url, body),
  put: <T,>(url: string, body?: unknown) => request<T>("PUT", url, body),
  del: <T,>(url: string) => request<T>("DELETE", url),
};
